<template>
  <hi-sub-page>
    <template v-if="groupMailId">
      <hi-page-column card grow>
        <hi-row separator gutter>
          <span class="ui-text-clickable">Schedule</span>
          <span class="ui-text-clickable">Send</span>
        </hi-row>
        <hi-row>
          {{ this.groupMailDoc.id }}
        </hi-row>

        <!--        <hi-row v-for="msg in opened" :key="msg.id" separator>-->
        <!--          <b-->
        <!--            ><di-details :lead-id="msg.uid">{{ msg.to.name }}</di-details> - </b-->
        <!--          >{{ msg.to.email }}-->
        <!--          <span v-if="msg.tracking.open.length < 2" class="ui-text-italic"-->
        <!--            >({{ msg.lastOpened | timestamp(true) }})</span-->
        <!--          >-->
        <!--          <div v-if="msg.tracking.open.length > 1">-->
        <!--            <div-->
        <!--              style="padding-left:50px"-->
        <!--              class="ui-text"-->
        <!--              v-for="open in msg.tracking.open"-->
        <!--              :key="open.timestamp.seconds"-->
        <!--            >-->
        <!--              {{ open.timestamp | timestamp(true) }}-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </hi-row>-->
      </hi-page-column>
    </template>
  </hi-sub-page>
</template>

<script>
import HiSubPage from "@/components/scaffold/HiSubPage";
import HiPageColumn from "@/components/scaffold/HiPageColumn";
import { db } from "@/db";
import HiRow from "@/components/scaffold/HiRow";
export default {
  name: "GroupMailStatView",
  components: { HiRow, HiSubPage, HiPageColumn },
  created() {
    console.log("statView created");
  },
  props: {
    // campaignId: {
    //   type: String
    // }
  },
  data() {
    return {
      messages: {},
      groupMailId: null,
      groupMailDoc: {}
    };
  },
  firestore() {
    return {
      messages: db
        .collection("emails/data/messages")
        .where("category", "==", "groupMail")
        .where("tag", "==", this.groupMailId),
      groupMailDoc: db
        .collection("emails/data/groupMails")
        .doc(this.groupMailId)
    };
  },
  methods: {},
  computed: {},
  watch: {
    $route: {
      immediate: true,
      handler(route) {
        if (route.params.groupMailId) {
          this.groupMailId = route.params.groupMailId;
          // console.log(this.campaignId);
          // this.$bind(
          //   "messages",
          //   db
          //     .collection("emails/data/messages")
          //     .where("category", "==", "campaign")
          //     .where("tag", "==", this.campaignId)
          // );
        }
      }
    }
  }
};
</script>

<style scoped></style>
